import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faFacebook, faLine } from "@fortawesome/free-brands-svg-icons";
import clsx from "clsx";

interface SNSShareSectionProps {
  url: string;
  text: string;
}

export function SNSShareSection({ url, text }: SNSShareSectionProps) {
  return (
    <ul role="list" className={clsx("flex", "items-center", "list-none")}>
      <li className={clsx("ml-4", "first:ml-0")}>
        <a
          href={`https://twitter.com/share?url=${encodeURIComponent(url)}&text=${text}`}
          target="_blank"
          rel="nofollow noopener noreferrer"
          title="このページをXでシェア"
          className={clsx(
            "block",
            "text-gray-600",
            "outline-none",
            "transition-colors",
            "hover:text-gray-900",
            "focus:text-gray-900"
          )}
        >
          <FontAwesomeIcon
            aria-hidden={false}
            icon={faTwitter}
            style={{
              width: "1.6rem",
              height: "1.6rem",
            }}
          />
        </a>
      </li>
      <li className={clsx("ml-4", "first:ml-0")}>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
          target="_blank"
          rel="nofollow noopener noreferrer"
          title="このページをfacebookでシェア"
          className={clsx(
            "block",
            "text-gray-600",
            "outline-none",
            "transition-colors",
            "hover:text-gray-900",
            "focus:text-gray-900"
          )}
        >
          <FontAwesomeIcon
            aria-hidden={false}
            icon={faFacebook}
            style={{
              width: "1.6rem",
              height: "1.6rem",
            }}
          />
        </a>
      </li>
      <li className={clsx("ml-4", "first:ml-0")}>
        <a
          href={`https://timeline.line.me/social-plugin/share?url=${encodeURIComponent(url)}&`}
          target="_blank"
          rel="nofollow noopener noreferrer"
          title="このページをLINEでシェア"
          className={clsx(
            "block",
            "text-gray-600",
            "outline-none",
            "transition-colors",
            "hover:text-gray-900",
            "focus:text-gray-900"
          )}
        >
          <FontAwesomeIcon
            aria-hidden={false}
            icon={faLine}
            style={{
              width: "1.6rem",
              height: "1.6rem",
            }}
          />
        </a>
      </li>
    </ul>
  );
}
